import { myGooruAPI } from '@/providers/apis/my-gooru/my-gooru';
import moment from 'moment';
import { Vue, Component, Prop } from 'vue-property-decorator';
import DateRangePicker from 'vue2-daterange-picker';
@Component({
    name: 'content-registry',
    components: {
        'date-range-picker': DateRangePicker,
    },
})

export default class GenerateNewAccesCode extends Vue {
    public fromDate: any;
    public filterDate: any;

    // Properties

    @Prop() private mygooruAccessList: any;
    @Prop() private interestListData: any = [];
    @Prop() private onEditAcessData: any;
    @Prop() private getEditIndexList: any;
    private tenantListTotalCount: any = '';
    private getAccessCodeGenerate = '';
    private searchTeantList = '';
    private tenantListData: any = [];
    private commentsErrorMsg = false;
    private dateErrorMsg = false;
    private noDataAvailable = false;
    private editDateErrorMsg = false;
    private errorMsg = false;
    private searchLoader = false;
    private editExpiryDate: any = null;

    private expiresDate: any = null;
    private getIndexStartDate: any = null;

    private startDate: any;

    private accessCreateSuccess = false;
    private pageLoader = false;

    private switchModel = false;
    private isCopiedSuccess = false;
    private isLoading = false;
    private onEditSuccessfully = false;
    private countCheck = 0;
    private offset = 0;
    private limit = 100;
    private getTenantId = '';
    private commentsField = '';
    private tenantSelectItem = 'MyGooru AI';
    private tenantId = '84b5e3d1-9152-4ec7-977c-eb187d0255b3';
    private dateRange: any = {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
    };
    private editDateRange: any = {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: null,
    };
    private selectedChips: any = [];

    public copyToClipboardAccesscodeSucces(text: any) {
        navigator.clipboard.writeText(text);
        this.isCopiedSuccess = true;
        setTimeout(() => {
            this.isCopiedSuccess = false;
        }, 1000);
    }


    // Hooks

    private created() {
        this.onEditAcessData = this.onEditAcessData ? true : false;
        if (this.onEditAcessData) {
            this.tenantSelectItem = this.getEditIndexList.customer_name;
            this.getTenantId = this.getEditIndexList.tenant_id;
            this.switchModel = this.getEditIndexList.is_active;
            this.getIndexStartDate = this.getEditIndexList.start_at == null ? '--' :
                moment(this.getEditIndexList.start_at).format('DD MMM YYYY');
            this.editExpiryDate = this.getEditIndexList.expires_at == null ? '' :
                moment(this.getEditIndexList.expires_at).format('DD MMM YYYY');
        } else {
            this.getTenantId = this.tenantId;
        }
        this.getTenantList();
    }

    private closePopUp() {
        this.$bvModal.hide('generate-new-acces-code');
    }

    private editAccessListSave() {
        if (this.commentsField.length === 0 || this.editExpiryDate == null) {
            this.commentsErrorMsg = this.commentsField.length === 0 ? true : false;
            this.editDateErrorMsg = this.editExpiryDate == null ? true : false;
        } else {
            this.pageLoader = true;
            const getTime = new Date();
            const getCurrentTime = getTime.toLocaleTimeString('en-US', { hour12: false });
            const getEditExpirayDate = this.editExpiryDate ? `${moment(this.editExpiryDate).format('YYYY-MM-DD')} ${getCurrentTime}` : '';
            const data: any = {
                customer_name: this.tenantSelectItem,
                id: this.getEditIndexList.id,
                expires_at: getEditExpirayDate,
                is_active: this.switchModel,
                comment: this.commentsField,
            };
            myGooruAPI.saveAccessList(data).then((response: any) => {
                if (response.status === 204) {
                    this.pageLoader = false;
                    this.mygooruAccessList();
                    this.onEditAcessData = false;
                    this.onEditSuccessfully = true;
                    this.accessCreateSuccess = true;
                }
            });
        }

    }

    private searchTeant() {

        if (this.searchTeantList.length > 3) {
            this.errorMsg = false;
            this.offset = 0;
            this.limit = 100;
            this.searchLoader = true;
            this.getTenantList();
        }
    }
    private searchTeanantListClear() {
        this.searchTeantList = '';
        this.offset = 0;
        this.limit = 100;

        this.getTenantList();
    }

    private commentsChange() {
        if (this.commentsField.length > 0) {
            this.commentsErrorMsg = false;
        } else {
            this.commentsErrorMsg = true;
        }

    }
    private generateNewAccessCode() {

        if (this.commentsField.length === 0 || this.expiresDate == null) {
            this.commentsErrorMsg = this.commentsField.length === 0 ? true : false;
            this.dateErrorMsg = this.expiresDate == null ? true : false;
        } else {
            this.pageLoader = true;
            const getTime = new Date();
            const getCurrentTime = getTime.toLocaleTimeString('en-US', { hour12: false });
            const expireDated = this.expiresDate ? `${moment(this.expiresDate).format('YYYY-MM-DD')} ${getCurrentTime}`
             : '';
            const startDate = this.startDate ? `${moment(this.startDate).format('YYYY-MM-DD')} ${getCurrentTime}` : '';
            const data: any = {
                customer_name: this.tenantSelectItem,
                tenant_id: this.getTenantId,
                settings: { interest: this.selectedChips },
                expires_at: expireDated,
                start_at: startDate,
                comment: this.commentsField,

            };
            myGooruAPI.getMyGooruAccessCreate(data).then((response: any) => {
                if (response.status === 201) {
                    this.pageLoader = false;
                    this.accessCreateSuccess = true;
                    this.mygooruAccessList();
                    this.getAccessCodeGenerate = response.headers.location;
                }
            });
        }

    }
    private getTenantList() {
        const offset = this.offset;
        const limit = this.limit;
        const name = this.searchTeantList;
        const params: any = {
            offset,
            limit,
            name,
        };

        myGooruAPI.getTenantList(params).then((response: any) => {
            this.countCheck++;
            this.searchLoader = false;
            this.isLoading = false;
            if (this.searchTeantList.length > 3) {
                this.tenantListData = [];
            }
            this.tenantListTotalCount = response.data.total_count;
            this.tenantListData.push(response.data.list);
            if (this.tenantListData[0].length === 0) {
                this.noDataAvailable = true;
            }
        });
    }

    private handleScroll(event: Event) {
        const target = event.target as HTMLElement;
        const roundOffValue = Math.trunc(target.scrollHeight - target.scrollTop);
        const scrollBottom = roundOffValue === target.clientHeight;
        const pageLimitCount = this.tenantListTotalCount / this.limit;
        if (scrollBottom && (this.countCheck < pageLimitCount)) {
            this.offset = this.offset + 100;
            this.isLoading = true;
            this.getTenantList();
        }
    }



    private dateFormat(classes: any, date: any) {
        if (!classes.disabled) {
            const a = moment(date.getTime()).format('DD MMM YYYY');
            const newdate = new Date().getTimezoneOffset() * 60000;
            const today = (new Date(Date.now() - newdate));
            const b = new Date(today.getTime());
            b.setDate(b.getDate() - 1);
            classes.disabled = moment(b).isAfter(a);
        }
        return classes;
    }

    private editDateFormat(classes: any, date: any) {
        if (!classes.disabled) {
            const a = moment(date.getTime()).format('DD MMM YYYY');
            const newdate = new Date().getTimezoneOffset() * 60000;
            const today = (new Date(Date.now() - newdate));
            const b = new Date(today.getTime());
            b.setDate(b.getDate() - 1);
            classes.disabled = moment(b).isAfter(a);
        }
        return classes;

    }

    private EditUpdateDate() {
        this.editExpiryDate = moment(this.editDateRange.endDate).format('DD MMM YYYY');
        if (this.editExpiryDate) {
            this.editDateErrorMsg = false;

        }
    }

    private updateValues() {
        this.expiresDate = `${moment(this.dateRange.endDate).format('YYYY-MM-DD')}`;
        this.startDate = `${moment(this.dateRange.startDate).format('YYYY-MM-DD')}`;
        if (this.expiresDate) {
            this.dateErrorMsg = false;
        }
        this.filterDate =
            moment(this.startDate).format('DD MMM YYYY') +
            '  -  ' +
            moment(this.dateRange.endDate).format('DD MMM YYYY');
    }
    private toggleChip(chip: any) {
        const index = this.selectedChips.indexOf(chip.id);
        if (index > -1) {
            this.selectedChips.splice(index, 1);
        } else {
            this.selectedChips.push(chip.id);
        }
    }
    private isSelected(chip: any) {
        return this.selectedChips.includes(chip.id);
    }

    private selectTenantItem(tenantSelectItem: any) {
        (this.$refs.dropdown as any).hide();
        this.tenantSelectItem = tenantSelectItem.name;
        this.getTenantId = tenantSelectItem.id;
    }


}
